import { defineStore } from 'pinia'
import axios from 'axios'

export const useTaskStore = defineStore('taskStore', {
  state: () => ({
    tasks: [],
    task: {},
    filters: {},
    sortOrder: '',
    taskStatuses: [
      {index: 'created', label: 'Created', weight: 0, colour: '#8d94b2', state: 'open'},
      {index: 'assigned', label: 'Assigned', weight: 10, colour: '#6473b3', state: 'open'},
      {index: 'in-progress', label: 'In Progress', weight: 20, colour: '#2d46b2', state: 'open'},
      {index: 'completed', label: 'Completed', weight: 30, colour: '#05C793', state: 'closed'},
      {index: 'blocked', label: 'Blocked', weight: 40, colour: '#EF436B', state: 'blocked'},
      {index: 'cancelled', label: 'Cancelled', weight: 50, colour: '#05C793', state: 'closed'},
      {index: 'on-hold', label: 'On Hold', weight: 60, colour: '#FFCE5C', state: 'closed'}
    ],
    taskPriorities: [
      {index: 'normal', label: 'Normal', weight: 0, colour: '#FFF5EB'},
      {index: 'high', label: 'High', weight: 10, colour: '#05C793'},
      {index: 'critical', label: 'Critical', weight: 20, colour: '#FFCE5C'},
      {index: 'epic', label: 'Epic', weight: 30, colour: '#EF436B'}
    ]
  }),
  getters: {
  },
  actions: {
    async updateFilters (prop, value, search = true) {
      if (value === null) {
        delete this.filters[prop]
      } else {
        this.filters[prop] = value
      }
      if (search !== false) {
        await this.loadTasks()
      }
    },
    async setFilters (filters = {}, search = true) {
      this.filters = filters
      if (search !== false) {
        await this.loadTasks()
      }
    },
    async setSortOrder (prop, dir = 1, search = true) {
      this.sortOrder = `&sort[][${prop}]=${dir}`
      if (search !== false) {
        await this.loadTasks()
      }
    },

    async loadTask (id) {
      const task = await axios.get(`/v2/tasks/${id}`)
      this.task = task.data
      if (this.task.project) {
        this.project = task.data.project
      }
    },
    async loadTasks () {
      const tasks = await axios.get(`/v2/tasks?` + new URLSearchParams(this.filters).toString() + '&' + this.sortOrder)
      this.tasks = tasks.data
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/TaskStore.js